export const createReducer = (initialState, handlers) => {
  return function reducer(state = initialState, action) {
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action.payload)
    }

    return state
  }
}

export const removeItemInArray = (array = [], isItemToRemove) =>
  array.filter(item => !isItemToRemove(item))

export const updateItemInArray = (array = [], isItemToModify, createNewValue) =>
  array.map(item => isItemToModify(item) ? createNewValue(item) : item)



// WEBPACK FOOTER //
// ./src/store/reducerUtils.js